import { Member } from "Common/DynamicComponentsForEnquiryQuotationSalesOrder/AssignedMemberSection";

// Interface for the Agent object nested inside sales_order_details
export interface AgentDetail {
    agent_name: string;
    agent_phone_no: string;
    agent_email: string;
    agent_designation: string;
    agent_department: string;
}

// Interface for documents/files (used in pbg_details)
export interface FileDetail {
    file_name: string;
    file_url: string;
}

// Interface for PBG (Performance Bank Guarantee) Details
export interface PBGDetail {
    pbg_required: boolean;
    pbg_number: string;
    pbg_date: string;
    bank_name: string;
    amount: number;
    validity: string;
    pbg_status: "Recieved" | "Pending" | "Waived" | string;
    next_follow_up_date?: string;
    upload_document: FileDetail[];
}

// Interface for Assigned Member Details
export interface AssignedMemberDetail {
    user: string; // This is expected to be a UUID string
}

// Interface for an Item/Service in the Sales Order
export interface ItemDetail {
    item: string; // UUID
    category: string; // UUID
    sub_category: string; // UUID
    make: string; // UUID
    model: string; // UUID
    installation: "Applicable" | "Not Applicable" | string;
    installation_date: string; // Date string (YYYY-MM-DD)
    inspection: "Applicable" | "Not Applicable" | string;
    inspection_date: string; // Date string (YYYY-MM-DD)
    quantity: number;
    unit_price: number;
    discount_percent: number;
    discount_amount: number;
    net_value: number;
    gst_percent: number;
    cgst_percent: number;
    igst_percent: number;
    sgst_percent: number;
    gst_amount: number;
    total_amount: number;
    is_serviceable: boolean;
    warranty_in_months: number;
    warranty_date: string;
    shipping_address: string;
    service_address: string;
    product_code: string;
    product_name: string;
    product_quantity: number;
    product_total: number;
    product_net_total: number;
    product_discount_type: string;
    product_discount_value: number;
    serial_number: string;
}

// Interface for general file attachments
export interface Attachment {
    file_name: string;
    file_path: string;
    file_size: number;
    file_type: string;
}

// Interface for the main Sales Order Details section
export interface SalesOrderDetail {
    sales_order_date: string; // Date string (YYYY-MM-DD)
    eta_date: string; // Date string (YYYY-MM-DD)
    enquiry: string; // UUID
    quotation: string; // UUID
    initiated_by: string;
    agent: AgentDetail;
    company: string; // This is expected to be a Company UUID string
    industry: string;
    contact_person_name: string;
    contact_person_designation: string;
    contact_person_phone_no: string;
    contact_person_email: string;
    payment_terms: string;
    subtotal_before_discount: number;
    total_item_discounts: number;
    net_taxable_value: number;
    total_gst: number;
    total_amount: number;
    terms_and_conditions: string;
    notes: string;
    status: "In Progress" | "Completed" | "Cancelled" | string;
}

// The comprehensive root interface for the Sales Order form data
export interface SalesOrderFormData {
    sales_order_details: SalesOrderDetail;
    pbg_details: PBGDetail;
    assigned_member_details: Member[];
    sales_order_products_items: ItemDetail[];
    attachments: Attachment[];
}



export const salesOrderFormData: SalesOrderFormData = {
    sales_order_details: {
        sales_order_date: "",
        eta_date: "",
        enquiry: "",
        quotation: "",
        initiated_by: "",
        agent: {
            agent_name: "",
            agent_phone_no: "",
            agent_email: "",
            agent_designation: "",
            agent_department: "",
        },
        company: "",
        industry: "",
        contact_person_name: "",
        contact_person_designation: "",
        contact_person_phone_no: "",
        contact_person_email: "",
        payment_terms: "",
        subtotal_before_discount: 0,
        total_item_discounts: 0,
        net_taxable_value: 0,
        total_gst: 0,
        total_amount: 0,
        terms_and_conditions: "",
        notes: "",
        status: "",
    },
    pbg_details: {
        pbg_required: true,
        pbg_number: "",
        pbg_date: "",
        bank_name: "",
        amount: 0,
        validity: "",
        pbg_status: "",
        upload_document: [
            {
                file_name: "",
                file_url: "",
            },
        ],
    },
    assigned_member_details: [
        {
            username: "",
            id:""
        },
    ],
    sales_order_products_items: [
        {
            item: "",
            category: "",
            sub_category: "",
            make: "",
            model: "",
            installation: "",
            installation_date: "",
            inspection: "",
            inspection_date: "",
            quantity: 0,
            unit_price: 0,
            discount_percent: 0,
            discount_amount: 0,
            net_value: 0,
            gst_percent: 0,
            cgst_percent: 0,
            igst_percent: 0,
            sgst_percent: 0,
            gst_amount: 0,
            total_amount: 0,
            is_serviceable: true,
            warranty_in_months: 0,
            warranty_date: "",
            shipping_address: "",
            service_address: "",
            product_code: "",
            product_name: "",
            product_quantity: 0,
            product_total: 0,
            product_net_total: 0,
            product_discount_type: "",
            product_discount_value: 0,
            serial_number: "",
        },
    ],
    attachments: [
        {
            file_name: "",
            file_path: "",
            file_size: 0,
            file_type: "",
        },
    ],
};
